import {
  StyleSheet,
  ImageBackground,
  useWindowDimensions,
  SafeAreaView,
  Image,
} from "react-native";
import React from "react";

import { View, ScrollView, Heading, Text, Pressable } from "native-base";
import Card from "../../components/Card";
import { StackScreenProps } from "../../types";
import BottomSlidingImages from "../../components/BottomSlidingImages";
import Header from "../../components/Header";

const PublicPatnerships = ({
  navigation,
}: StackScreenProps<"ResearchAndDev">) => {
  const { height, width } = useWindowDimensions();

  const data = [
    {
      heading: "CSR",
      subheading: "Scholarship granted to 5+ universities",
      details:
        "At OCP Africa, we believe corporations must do good by being good corporate citizens hence, we invest in the lives and communities we reach through scholarships and community support",
      iconName: "",
      onPress: () => navigation.navigate("CSR"),
      image: require("../../assets/vectors/search.png"),
    },
    {
      heading: "Government Partnerships",
      subheading: "Presidential Fertilizer Initiative",
      details:
        "PFI is a government initiative partnership to address the challenges encountered in the Nigerian fertilizer sector such as late delivery, price distortion, late payment of suppliers and crowding out of the private sector by subsidy programs which affects  fertilizer availability and affordability to farmers.",
      iconName: "",
      onPress: () => navigation.navigate("GovernmentPartnerships"),
      image: require("../../assets/vectors/handshake.png"),
    },
  ];

  const partners = [
    { image: require("../../assets/partners/uniabuja.png"), name: "UNIABUJA" },
    { image: require("../../assets/partners/npfl.png"), name: "NPFL" },
    { image: require("../../assets/partners/kadsu.png"), name: "" },
    { image: require("../../assets/partners/akwa.png"), name: "" },
    { image: require("../../assets/partners/bsu.png"), name: "BSU" },
  ];

  return (
    <ImageBackground
      source={require("../../assets/background.png")}
      resizeMode="repeat"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView
            px={5}
            contentContainerStyle={{
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            <View>
              <Header
                onPress={() => navigation.navigate("Home")}
                headingText="Partnerships"
                intro="OCP Africa leverages on public and private partnerships, to develop and amplify the reach of its projects. We align our projects with that of federal and state governments for cohesion and efficacy."
              />

              {data.map((item) => (
                <Pressable key={item.heading} mb={10} onPress={item.onPress}>
                  <Card
                    heading={item.heading}
                    subheading={item.subheading}
                    details={item.details}
                    iconName={item.iconName}
                    onPress={item.onPress}
                    borderBottomColor="#333"
                    borderColor="#bbb"
                    bg="rgba(41, 124, 224, 1)"
                    image={item?.image}
                  />
                </Pressable>
              ))}
            </View>

            <BottomSlidingImages partners={partners} />
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default PublicPatnerships;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(41, 124, 224, 0.7)",
  },
});
